import * as React from 'react';
import cn from 'classnames';
import SubsidiesSelector from './SubsidiesSelector';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '../../../Radio';
import Checkbox from '@mui/material/Checkbox';
import { useCallback } from 'react';
import { useTheme } from '../../../theme';
import { format } from '../../../utils';
var SubsidiesSelectorRadio = function (_a) {
    var subsidiesSegments = _a.subsidiesSegments, segments = _a.segments, onSelect = _a.onSelect, id = _a.id, type = _a.type, disabled = _a.disabled, selectedSubsidies = _a.selectedSubsidies;
    var theme = useTheme('Subsidies').SubsidiesSelectorRadio;
    var isSelected = subsidiesSegments.some(function (subsidySegment) {
        return selectedSubsidies.some(function (selectedSubsidy) { return selectedSubsidy.subsidyId === subsidySegment.id; });
    });
    var handleChange = useCallback(function () {
        var selectedSubsidies = subsidiesSegments
            .filter(function (subsidySegment) { return !subsidySegment.rejectMessage; })
            .map(function (subsidySegment) { return ({
            subsidyId: subsidySegment.id,
            segmentId: subsidySegment.segmentId
        }); });
        if (selectedSubsidies.length) {
            onSelect(selectedSubsidies);
        }
    }, [subsidiesSegments, selectedSubsidies]);
    var handleSegmentChange = useCallback(function (e, subsidySegment) {
        e.stopPropagation();
        onSelect([
            {
                segmentId: subsidySegment.segmentId,
                subsidyId: subsidySegment.id
            }
        ]);
    }, [subsidiesSegments, selectedSubsidies]);
    var isAllSubsidiesUnavailable = subsidiesSegments.every(function (subsidyOnSegment) { return !!subsidyOnSegment.rejectMessage; });
    return (React.createElement(SubsidiesSelector, { onChange: handleChange, containerClassName: theme.container, disabled: isAllSubsidiesUnavailable, isSelected: isSelected, id: id, type: type, content: function (_a) {
            var isActive = _a.isActive, onChange = _a.onChange, icon = _a.icon, title = _a.title;
            return (React.createElement(FormControlLabel, { className: theme.label, onChange: function (e) {
                    if (!isAllSubsidiesUnavailable) {
                        onChange(e);
                        handleChange();
                    }
                }, disabled: isAllSubsidiesUnavailable, control: React.createElement(React.Fragment, null,
                    React.createElement(Radio, { className: theme.radio, onChange: handleChange, checked: isSelected })), label: React.createElement("div", null,
                    React.createElement("span", { className: theme.icon }, icon),
                    React.createElement("span", { className: theme.title }, title),
                    React.createElement("div", { className: theme.segments }, subsidiesSegments.map(function (subsidySegment) {
                        var _a;
                        var segment = segments.find(function (segment) { return segment.id === subsidySegment.segmentId; });
                        var isSegmentAvailable = !subsidySegment.rejectMessage;
                        return (React.createElement("div", { className: cn(theme.segment, (_a = {},
                                _a[theme.disabled] = !isAllSubsidiesUnavailable && !isSegmentAvailable,
                                _a)) },
                            React.createElement(Checkbox, { key: subsidySegment.segmentId, disabled: !isSegmentAvailable, onChange: function (e) { return handleSegmentChange(e, subsidySegment); }, checked: !!selectedSubsidies.find(function (selectedSubsidy) {
                                    return selectedSubsidy.segmentId === subsidySegment.segmentId;
                                }) }),
                            segment.departure.airport.city.name,
                            " - ",
                            segment.arrival.airport.city.name,
                            ",\u00A0",
                            format(segment.departure.date, 'dd MMM, eeeeee').replace('.', ''),
                            React.createElement("div", { className: theme.rejectMessage }, subsidySegment.rejectMessage)));
                    }))) }));
        } }));
};
export default SubsidiesSelectorRadio;
